export interface ISpinButtonView {
    spinButtonClickAction(): void;

    enableSpinButton(): void;

    disableSpinButton(): void;

    initFreeSpins(): void;

    initMainGame(): void;

    initAutoplay(): void;

    uninitAutoplay(): void;

    onSpinStarted(): void;

    isSpinButtonEnabled(): boolean;
}
